var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1934(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.02,
    height: 20,
    viewBox: "0 0 20.02 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1934",
    "data-name": "Group 1934",
    transform: "translate(361.134 -167.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    "data-name": "Path 3754",
    d: "M-346.844,187.369a14.394,14.394,0,0,1-10.35-4.569,14.062,14.062,0,0,1-3.712-7.376,10.272,10.272,0,0,1-.124-3.535,5.626,5.626,0,0,1,4.441-4.48,2.841,2.841,0,0,1,1.082.026,1.387,1.387,0,0,1,.952.859q1.019,2.363,2.027,4.73a1.536,1.536,0,0,1-.152,1.5c-.507.785-1.017,1.568-1.536,2.345a.34.34,0,0,0-.015.407,7.741,7.741,0,0,0,3.244,3.209.3.3,0,0,0,.359-.024c.739-.5,1.488-.987,2.225-1.49a1.669,1.669,0,0,1,1.726-.163c1.443.628,2.884,1.261,4.345,1.846a1.77,1.77,0,0,1,1.158,2.217,5.642,5.642,0,0,1-4.886,4.437C-346.334,187.342-346.609,187.352-346.844,187.369Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    d: "M-122.384,181.784c.234.075.606.17.959.311a8.709,8.709,0,0,1,5.4,5.96.767.767,0,0,1-.295.863.739.739,0,0,1-.887.018,1.292,1.292,0,0,1-.375-.564,7.548,7.548,0,0,0-1.4-2.63,7.277,7.277,0,0,0-3.731-2.393.772.772,0,0,1-.61-.757C-123.333,182.133-122.987,181.782-122.384,181.784Z",
    transform: "translate(-225.885 -13.692)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756",
    "data-name": "Path 3756",
    d: "M-135.058,247.824a.813.813,0,0,1-.693.859.8.8,0,0,1-.849-.521c-.079-.21-.133-.431-.226-.635a4.034,4.034,0,0,0-2.635-2.281.808.808,0,0,1-.64-.991.806.806,0,0,1,1.092-.535,5.51,5.51,0,0,1,3.907,3.9A1.906,1.906,0,0,1-135.058,247.824Z",
    transform: "translate(-209.92 -72.476)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1934);
export default __webpack_public_path__ + "static/media/Group 1934.53b41699b70a7d27f5a09f653e25fbb4.svg";
export { ForwardRef as ReactComponent };